import { FC } from "react";
import GenericCrudTable from "@/components/tables/genericCrudTable";
import { getRecordMetadataColumns } from "@/components/tables/recordMetadataColumns";
import { useTranslation } from "react-i18next";
import { formEntityAdapter } from "@/components/probe/formEntityAdapter";

interface Props {
  probeId: any;
  customRowActions?: any;
  customCreatePresetValues?: any;
  additionalSubmitDataForCreate?: any;
  additionalOnSuccessfulCreateFunction?: any;
  additionalRoutePartsForDelete?: any;
  customDeleteHandler?: any;
  resetFormtable?: boolean;
  customDeleteFunction?: any;
}

const ProbeEditorFormCrud: FC<Props> = ({
  probeId,
  customRowActions,
  customCreatePresetValues,
  additionalSubmitDataForCreate,
  additionalOnSuccessfulCreateFunction,
  additionalRoutePartsForDelete,
  customDeleteHandler,
  resetFormtable,
  // eslint-disable-next-line
  customDeleteFunction,
}) => {
  const { t } = useTranslation();
  const columns = [
    { header: t("id"), accessorKey: "id", id: "id" },
    {
      header: t("name"),
      accessorKey: "name",
      id: "name",
      required: true,
      errorMessage: t("field_required"),
      enableForCreate: true,
    },
    {
      header: t("fillable_by_portal_user_short"),
      enableGlobalFilter: false,
      accessorKey: "editable_by_subject",
      id: "editable_by_subject",
      filterVariant: "select",
      filterSelectOptions: [
        { value: "true", label: t("yes") },
        { value: "false", label: t("no") },
      ],
      setNoFilterParameter: true,
      enableForCreate: true,
      selectOptions: [
        { value: true, label: t("yes") },
        { value: false, label: t("no") },
      ],
      accessorFn: (row: any) => {
        if (row.editable_by_subject) {
          return t("yes");
        } else return t("no");
      },
    },
    {
      header: t("widget_for", { view: t("appointment_dashboard") }),
      accessorKey: "appointment_dashboard_widget",
      id: "appointment_dashboard_widget",
      filterVariant: "select",
      filterSelectOptions: [
        { value: "true", label: t("yes") },
        { value: "false", label: t("no") },
      ],
      setNoFilterParameter: true,
      enableForCreate: true,
      selectOptions: [
        { value: true, label: t("yes") },
        { value: false, label: t("no") },
      ],
      accessorFn: (row: any) => {
        if (row.appointment_dashboard_widget !== null) {
          if (row.appointment_dashboard_widget) {
            return t("yes");
          } else {
            return t("no");
          }
        } else return "-";
      },
    },
    {
      header: t("widget_for", { view: t("subject_company_overview") }),
      accessorKey: "subject_overview_widget",
      id: "subject_overview_widget",
      filterVariant: "select",
      filterSelectOptions: [
        { value: "true", label: t("yes") },
        { value: "false", label: t("no") },
      ],
      setNoFilterParameter: true,
      enableForCreate: true,
      selectOptions: [
        { value: true, label: t("yes") },
        { value: false, label: t("no") },
      ],
      accessorFn: (row: any) => {
        if (row.subject_overview_widget !== null) {
          if (row.subject_overview_widget) {
            return t("yes");
          } else {
            return t("no");
          }
        } else return "-";
      },
    },
    {
      header: t("widget_hidden_form"),
      accessorKey: "hidden",
      id: "hidden",
      filterVariant: "select",
      filterSelectOptions: [
        { value: "true", label: t("yes") },
        { value: "false", label: t("no") },
      ],
      setNoFilterParameter: true,
      enableForCreate: true,
      selectOptions: [
        { value: true, label: t("yes") },
        { value: false, label: t("no") },
      ],
      accessorFn: (row: any) => {
        if (row.hidden !== null) {
          if (row.hidden) {
            return t("yes");
          } else {
            return t("no");
          }
        } else return "-";
      },
    },
    {
      header: t("widget_priority"),
      accessorKey: "widget_priority",
      enableForCreate: true,
      textfieldType: "number",
    },
    {
      header: t("widget_id"),
      accessorKey: "widget_id",
      enableForCreate: true,
    },
    {
      header: t("widget_title"),
      accessorKey: "widget_title",
      enableForCreate: true,
    },
    {
      header: t("form_additional_measurement_uploads"),
      accessorKey: "enable_additional_measurement_uploads",
      id: "enable_additional_measurement_uploads",
      filterVariant: "select",
      filterSelectOptions: [
        { value: "true", label: t("yes") },
        { value: "false", label: t("no") },
      ],
      setNoFilterParameter: true,
      enableForCreate: true,
      selectOptions: [
        { value: true, label: t("yes") },
        { value: false, label: t("no") },
      ],
      accessorFn: (row: any) => {
        if (row.enable_additional_measurement_uploads) {
          return t("yes");
        } else {
          return t("no");
        }
      },
    },
    ...getRecordMetadataColumns(t, [
      "created_on",
      "created_by",
      "modified_on",
      "modified_by",
    ]),
  ];

  return (
    <>
      <GenericCrudTable
        entity="form"
        entityAdapter={formEntityAdapter}
        columns={columns}
        customPageSize={5}
        additionalUrlParameter={{
          probe: probeId,
        }}
        customRowActions={customRowActions}
        customCreatePresetValues={customCreatePresetValues}
        additionalSubmitDataForCreate={additionalSubmitDataForCreate}
        additionalOnSuccessfulCreateFunction={
          additionalOnSuccessfulCreateFunction
        }
        additionalRoutePartsForDelete={additionalRoutePartsForDelete}
        customDeleteHandler={customDeleteHandler}
        uploadSuccessful={resetFormtable}
      />
    </>
  );
};

export default ProbeEditorFormCrud;
